import { render, staticRenderFns } from "./UniversityTemplateTable.vue?vue&type=template&id=7a37ffef&scoped=true&"
import script from "./UniversityTemplateTable.vue?vue&type=script&lang=js&"
export * from "./UniversityTemplateTable.vue?vue&type=script&lang=js&"
import style0 from "./UniversityTemplateTable.vue?vue&type=style&index=0&id=7a37ffef&scoped=scss&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a37ffef",
  null
  
)

export default component.exports